/**
 * Whether a stored call (vrs_active_call) may go on hold: never one with an
 * interpreter, VRS or VRI. Robert, 2026-10-12, on VRS: the FCC "will never
 * approve" putting the interpreter on hold; VRI too. The server enforces the
 * same rule (vrs-server/lib/call-hold-policy.js).
 *
 * @param {Object} record - The stored call.
 * @returns {boolean}
 */
export function canHoldStoredCall(record) {
    return Boolean(record?.callId) && !record?.interpreterId
        && record?.callType !== 'vrs' && record?.callType !== 'vri';
}
